import PropTypes from 'prop-types'
import React from 'react'
import {Box, Button, Dialog} from '@chakra-ui/react3'
import useScrollLock from '../../../hooks/use-scroll-lock'

const ConfirmationModal = ({
    isOpen,
    onClose,
    title,
    children,
    primaryActionLabel,
    secondaryActionLabel,
    onPrimaryAction,
    onSecondaryAction,
    placement
}) => {
    useScrollLock(isOpen)

    const handlePrimaryAction = () => {
        onPrimaryAction?.()
    }

    const handleSecondaryAction = () => {
        onSecondaryAction?.()
    }

    return (
        <Dialog.Root
            placement={placement}
            size={'sm'}
            scrollBehavior="inside"
            open={isOpen}
            onOpenChange={({open}) => {
                if (!open) onClose?.()
            }}
        >
            <Dialog.Backdrop>
                <Dialog.Positioner>
                    <Dialog.Content>
                        <Dialog.Header>
                            <Dialog.Title as="h1">{title}</Dialog.Title>
                        </Dialog.Header>

                        <Dialog.Body>{children}</Dialog.Body>

                        <Dialog.Footer>
                            <Button
                                variant="secondaryFilled"
                                size="sm"
                                flex="1 0 0"
                                onClick={handlePrimaryAction}
                            >
                                <Box as="span">{primaryActionLabel}</Box>
                            </Button>

                            <Button
                                variant="secondaryOutline"
                                size="sm"
                                flex="1 0 0"
                                onClick={handleSecondaryAction}
                            >
                                <Box as="span">{secondaryActionLabel}</Box>
                            </Button>
                        </Dialog.Footer>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Dialog.Backdrop>
        </Dialog.Root>
    )
}

ConfirmationModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    title: PropTypes.node,
    children: PropTypes.node,
    primaryActionLabel: PropTypes.node,
    secondaryActionLabel: PropTypes.node,
    onPrimaryAction: PropTypes.func,
    onSecondaryAction: PropTypes.func,
    size: PropTypes.string,
    placement: PropTypes.oneOf(['center', 'bottom'])
}

export default ConfirmationModal
